import { render, staticRenderFns } from "./orders_page.vue?vue&type=template&id=37b132f4&scoped=true&"
import script from "./orders_page.vue?vue&type=script&lang=js&"
export * from "./orders_page.vue?vue&type=script&lang=js&"
import style0 from "./orders_page.vue?vue&type=style&index=0&id=37b132f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b132f4",
  null
  
)

export default component.exports